import { RpxResponse, rpx } from 'client/lib/rpx-client';
import { AiMessage, AiProfile } from 'server/types/cal-overrides';

export type LocalInterviewState = {
  messages: AiMessage[];
  profile?: AiProfile;
  name: string;
  aiData?: RpxResponse<typeof rpx.aiInterview.generateCalendarPage>;
};

export function getAiInterview(name?: string) {
  const json = localStorage.aiInterview || 'null';
  const obj = (JSON.parse(json) || {}) as LocalInterviewState;
  obj.messages ||= [];
  obj.name ||= name || '';
  return obj;
}

export function saveAiInterview(state: LocalInterviewState) {
  localStorage.aiInterview = JSON.stringify(state);
}
